import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
// import config from './aws-exports'
Amplify.configure({
  "aws_project_region": "us-east-1",
  "aws_cognito_identity_pool_id": "us-east-1:0db79a0a-0f8a-4b4e-b40a-a391a825b362",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_Je7d8Vt7C",
  "aws_user_pools_web_client_id": "3uvt4462pobut6jo1f8orirhro",
  "aws_cloud_logic_custom": [
    {
      "name": "cashcrewchosen",
      "endpoint": "https://h9fmf0qw83.execute-api.us-east-1.amazonaws.com/prod",
      "region": "us-east-1"
    }
  ],
  "oauth": {},
  "aws_cognito_username_attributes": [],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "cashcrewio90a6c86a16094e0486e4ed2e883587bf60607-dev",
  "aws_user_files_s3_bucket_region": "us-east-1"
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
